import { StageBadge } from '@/code/frontend/components/chats/shared/StageBadge';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/code/frontend/components/ui/avatar';
import { CommandItem } from '@/code/frontend/components/ui/command';
import { initials } from '@/code/lib/utils/initials';
import type { RouterOutput } from '@/code/lib/utils/trpc';

type ActiveLeadSearchResult = RouterOutput['leads']['searchActive'][number];

interface CmdKLeadItemProps {
  lead: ActiveLeadSearchResult;
  onSelect: (lead: ActiveLeadSearchResult) => void;
}

/**
 * Renders a single lead search result in the command palette.
 */
export function CmdKLeadItem({ lead, onSelect }: CmdKLeadItemProps) {
  return (
    <CommandItem
      key={lead.id}
      value={`lead-${lead.id}`}
      onSelect={() => onSelect(lead)}
      className="flex items-center gap-3 p-3"
    >
      <Avatar className="h-8 w-8">
        {lead.imageData && (
          <AvatarImage src={lead.imageData} alt={lead.fullName ?? ''} />
        )}
        <AvatarFallback className="text-xs">
          {initials(lead.fullName ?? '?')?.toUpperCase() ?? '?'}
        </AvatarFallback>
      </Avatar>
      <div className="flex-1 min-w-0">
        <div className="font-medium truncate text-sm">{lead.fullName}</div>
        <div className="text-xs text-muted-foreground truncate">
          {lead.title} at {lead.currentCompany}
        </div>
      </div>
      <StageBadge stage={lead.stage} type="lead" />
    </CommandItem>
  );
}
